module.exports = {
	"root": "findify-layouts--custom"
};